import React, {memo} from "react";

const SelectOptionsPanel = ({options, selectedIdx, setSelectedIdx}: {options: string[], selectedIdx: number, setSelectedIdx: React.Dispatch<React.SetStateAction<number>> }) => {
    return (
        <div className="select-option-panel">
            {(options).map((option, idx) => <SelectOptionButton key={option} option={option} isSelected={idx === selectedIdx} makeSelected={() => setSelectedIdx(idx)}/>)}
        </div>
    );
};

const SelectOptionButton = ({option, isSelected, makeSelected}: {option: string, isSelected: boolean, makeSelected: () => void}) => (
    <div
        className={"select-option-panel-button option-panel-button-"+(isSelected? "":"un")+"selected"}
        onClick={() => makeSelected()}>
        <p>{option}</p>
    </div>
);

export default memo(SelectOptionsPanel);
